/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createListForecastModelsResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ListForecastModelsResponse } from '../../../models/index.js';
// @ts-ignore
import { type WithModelItemRequestBuilder, WithModelItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { OrderVolumeRequestBuilderNavigationMetadata, type OrderVolumeRequestBuilder } from './orderVolume/index.js';
// @ts-ignore
import { SkuRequestBuilderNavigationMetadata, type SkuRequestBuilder } from './sku/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/forecasting/models
 */
export interface ModelsRequestBuilder extends BaseRequestBuilder<ModelsRequestBuilder> {
    /**
     * The orderVolume property
     */
    get orderVolume(): OrderVolumeRequestBuilder;
    /**
     * The sku property
     */
    get sku(): SkuRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.forecasting.modelsRequests.item collection
     * @param modelId Route parameter: the model to retrieve, as listed by GET /api/forecasting/models.
     * @returns {WithModelItemRequestBuilder}
     */
     byModelId(modelId: string) : WithModelItemRequestBuilder;
    /**
     * Returns the models the organisation has trained, so a caller can compare accuracy across versions or pick a modelId to pin a forecast to. The model flagged isCurrent is the one a forecast uses when no modelId is passed; earlier versions stay listed, which is what makes a rollback to a known-good version possible. An organisation that has trained nothing gets an empty list, not a 404. Filter with the optional modelType query parameter.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ListForecastModelsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ModelsRequestBuilderGetQueryParameters> | undefined) : Promise<ListForecastModelsResponse | undefined>;
    /**
     * Returns the models the organisation has trained, so a caller can compare accuracy across versions or pick a modelId to pin a forecast to. The model flagged isCurrent is the one a forecast uses when no modelId is passed; earlier versions stay listed, which is what makes a rollback to a known-good version possible. An organisation that has trained nothing gets an empty list, not a 404. Filter with the optional modelType query parameter.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ModelsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns the models the organisation has trained, so a caller can compare accuracy across versions or pick a modelId to pin a forecast to. The model flagged isCurrent is the one a forecast uses when no modelId is passed; earlier versions stay listed, which is what makes a rollback to a known-good version possible. An organisation that has trained nothing gets an empty list, not a 404. Filter with the optional modelType query parameter.
 */
export interface ModelsRequestBuilderGetQueryParameters {
    /**
     * Optional filter on the model family, matching the modelType reported on each model. Omit itto list every model the organisation has trained.
     */
    modelType?: string;
}
/**
 * Uri template for the request builder.
 */
export const ModelsRequestBuilderUriTemplate = "{+baseurl}/api/forecasting/models{?modelType*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ModelsRequestBuilderNavigationMetadata: Record<Exclude<keyof ModelsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byModelId: {
        requestsMetadata: WithModelItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["modelId"],
    },
    orderVolume: {
        navigationMetadata: OrderVolumeRequestBuilderNavigationMetadata,
    },
    sku: {
        navigationMetadata: SkuRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ModelsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ModelsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createListForecastModelsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
